import { ArrowRightIcon } from "@phosphor-icons/react";
import { Card } from "../ui/card";

interface ResourceCardProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  url: string;
  buttonText: string;
}

export function ResourceCard({
  icon,
  title,
  subtitle,
  url,
  buttonText,
}: ResourceCardProps) {
  return (
    <Card className="w-full px-spacing-6 pt-spacing-5 pb-spacing-6 flex flex-col justify-between">
      <div className="flex flex-col gap-spacing-3">
        {icon}
        <h4 className="text-palette-text-primary h4-Medium">{title}</h4>
        <p className="paragraphs-Large-Medium text-palette-text-secondary">
          {subtitle}
        </p>
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-spacing-2 text-palette-text-primary paragraphs-Medium-Medium"
      >
        <p className="underline">{buttonText}</p>
        <ArrowRightIcon size={16} />
      </a>
    </Card>
  );
}
